export default "__VITE_ASSET__7qnwbjJG__"